import { styled } from 'styled-components'
import { ToolbarButtonWrapper } from '../../../generic/buttons'

export const GfcrPageUnavailablePadding = styled.div`
  padding-top: 50px;
`

export const StyledToolbarButtonWrapper = styled(ToolbarButtonWrapper)`
  display: flex;
`
